import React, { useState } from "react";
import { venueDescriptions } from "../utils/venueData";
import embassy from "../images/home/embassy.jpg";
import embassyLogo from "../images/venue/icons/new/embassy.png";
import mine from "../images/pages/g02.png";
import mineLogo from "../images/venue/icons/new/mine.png";
import maze from "../images/pages/g03.png";
import mazeLogo from "../images/venue/icons/new/maze.png";
import lockhart88 from "../images/home/fz4.png";
import lockhart88Logo from "../images/venue/icons/new/lockhart88.png";
import port from "../images/pages/g05.png";
import portLogo from "../images/venue/icons/new/port.png";
import taboo from "../images/home/fz6.png";
import tabooLogo from "../images/venue/icons/new/taboo.png";
import graffiti from "../images/home/fz7.png";
import graffitiLogo from "../images/venue/icons/new/graffiti.png";
import gate from "../images/pages/g08.png";
import gateLogo from "../images/venue/icons/new/gate.png";
import theStation from "../images/home/fz9.png";
import theStationLogo from "../images/venue/icons/new/thestation.png";
import centrico from "../images/home/fz10.png";
import centricoLogo from "../images/venue/icons/new/centrico.png";

import g1 from "../images/gallery/gallery1.png";
import g3 from "../images/gallery/gallery3.png";

const HomepageHappening = () => {
  const [activeVenues, setActiveVenues] = useState({});

  const toggleVenue = (venueName) => {
    setActiveVenues(prev => ({
      ...prev,
      [venueName]: !prev[venueName]
    }));
  };

  const venueContents = {
    embassy: {
      title: "EMBASSY",
      subtitle: "Menu News",
      description: venueDescriptions.embassy,
      website: "https://embassy.zincgroup.com.hk",
      images: {
        main: embassy,
        logo: embassyLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Embassy" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Embassy" }
        ]
      }
    },
    mine: {
      title: "MINE",
      subtitle: "Menu News",
      description: venueDescriptions.mine,
      website: "https://mine.zincgroup.com.hk",
      images: {
        main: mine,
        logo: mineLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Mine" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Mine" }
        ]
      }
    },
    maze: {
      title: "MAZE",
      subtitle: "Menu News",
      description: venueDescriptions.maze,
      website: "https://maze.zincgroup.com.hk",
      images: {
        main: maze,
        logo: mazeLogo,
        gallery: [
          { image: g3, title: "Long Island", description: "Introducing our new Tapas menu in the Maze" },
          { image: g1, title: "Satays", description: "Introducing our new Tapas menu in the Maze" }
        ]
      }
    },
    LOCKHART88: {
      title: "LOCKHART88",
      subtitle: "Menu News",
      description: venueDescriptions.lockhart88,
      website: "https://lockhart88.zincgroup.com.hk",
      images: {
        main: lockhart88,
        logo: lockhart88Logo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Port" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Port" }
        ]
      }
    },
    port: {
      title: "PORT",
      subtitle: "Menu News",
      description: venueDescriptions.port,
      website: "https://port.zincgroup.com.hk",
      images: {
        main: port,
        logo: portLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Port" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Port" }
        ]
      }
    },
    TABOO: {
      title: "TABOO",
      subtitle: "Menu News",
      description: venueDescriptions.taboo,
      website: "https://taboo.zincgroup.com.hk",
      images: {
        main: taboo,
        logo: tabooLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Taboo" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Taboo" }
        ]
      }
    },
    // graffiti: {
    //   title: "GRAFFITI",
    //   subtitle: "Menu News",
    //   description: venueDescriptions.graffiti,
    //   website: "https://graffiti.zincgroup.com.hk",
    //   hidden: true,
    //   images: {
    //     main: graffiti,
    //     logo: graffitiLogo,
    //     gallery: [
    //       { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Graffiti" },
    //       { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Graffiti" }
    //     ]
    //   }
    // },
    gate: {
      title: "GATE",
      subtitle: "Menu News",
      description: venueDescriptions.gate,
      website: "https://gate.zincgroup.com.hk",
      images: {
        main: gate,
        logo: gateLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Gate" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Gate" }
        ]
      }
    },
    theStation: {
      title: "THE STATION",
      subtitle: "Menu News",
      description: venueDescriptions.thestation,
      website: "https://thestation.zincgroup.com.hk",
      images: {
        main: theStation,
        logo: theStationLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the The Station" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the The Station" }
        ]
      }
    },
    centrico: {
      title: "CENTRICO",
      subtitle: "Menu News",
      description: venueDescriptions.centrico,
      website: "https://centrico.zincgroup.com.hk",
      images: {
        main: centrico,
        logo: centricoLogo,
        gallery: [
          { image: g1, title: "Long Island", description: "Introducing our new Tapas menu in the Centrico" },
          { image: g3, title: "Satays", description: "Introducing our new Tapas menu in the Centrico" }
        ]
      }
    }
  };

  // 修改渲染函数，使用 index 判断方向
  const renderBigHidden = (venue, index) => (
    <a
      target="_blank"
      rel="noreferrer"
      href={venue.website}
      className={`rendar${index % 2 === 1 ? "2" : ""}TextWrap`}>
      <h4>{venue.title}</h4>
      {/* <p>{venue.subtitle}</p> */}
      <p className="rendar_description">{venue.description}</p>
      <div
        className={index % 2 === 1 ? "rightHappeningImages" : "happeningImages"}
      >
        {/* onClick={() => toggleVenue(venue.key)} */}
        <img src={venue.images.main} alt="" className="bigImage" />
        <div className={index % 2 === 1 ? "rightHappeningLogo" : "happeningLogo"}>
          <img src={venue.images.logo} alt="" className="smallLogo" />
        </div>
      </div>
    </a>
  );

  // 修改渲染函数，使用 index 判断方向
  const renderBigShown = (venue, index) => (
    <div className="div">
      <div className={`hidden${venue.title}TextWrap`}>
        <div className={index % 2 === 1 ? "divvRight" : "divv"}>
          <h4>{venue.title}</h4>
          {/* <p>{venue.subtitle}</p> */}
          <p className="rendar_description">{venue.description}</p>
          <div
            className={index % 2 === 1 ? "rightHappeningImages" : "happeningImages"}
            onClick={() => toggleVenue(venue.key)}
          >
            <img src={venue.images.main} alt="" className="bigImage" />
            <div className={index % 2 === 1 ? "rightHappeningLogo" : "happeningLogo"}>
              <img src={venue.images.logo} alt="" className="smallLogo" />
            </div>
          </div>
        </div>
      </div>
      <div className={`expand${index % 2 === 1 ? "Right" : "Left"} text-center`}>
        <div className="container">
          <div className="row">
            {venue.images.gallery.map((image, index) => (
              <div key={index} className="col-6 dottedBorderRow">
                <div className="eImageHolder">
                  <img src={image.image} alt="" className="smallMiniImages" />
                </div>
                <div className="blackColor">
                  <p>{image.title}</p>
                  <p>{image.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // 渲染小屏幕隐藏状态
  const renderSmallHidden = (venue) => (
    <a className="smallTextWrap"
      target="_blank"
      rel="noreferrer"
      href={venue.website}>
      <h4>{venue.title}</h4>
      {/* <p>{venue.subtitle}</p> */}
      <div className="borderDiv">
        <p>{venue.description}</p>
      </div>
      <div
        className="miniHappeningImages"
      >
        {/* onClick={() => toggleVenue(venue.key)} */}
        <img src={venue.images.main} alt="" className="miniBigImage" />
        {/* <div className="miniHappeningLogo">
          <img src={venue.images.logo} alt="" className="miniSmallLogo" />
        </div> */}
      </div>
    </a>
  );

  // 渲染小屏幕展开状态
  const renderSmallShown = (venue) => (
    <div className="whiteDiv">
      <div className="whiteSmallTextWrap">
        <h4>{venue.title}</h4>
        {/* <p>{venue.subtitle}</p> */}
        <div className="whiteBorderDiv">
          <p>{venue.description}</p>
        </div>
        <div
          className="miniHappeningImages"
          onClick={() => toggleVenue(venue.key)}
        >
          <img src={venue.images.main} alt="" className="whiteMiniBigImage" />
          <div className="miniHappeningLogo">
            <img src={venue.images.logo} alt="" className="whiteMiniSmallLogo" />
          </div>
        </div>
      </div>
      <div className="miniExpandImages text-center">
        {venue.images.gallery.map((image, index) => (
          <div key={index} className={index === 0 ? "dottedBorderRow" : ""}>
            <div className="eImageHolder">
              <img src={image.image} alt="" className="smallMiniImages" />
            </div>
            <div className="blackColor">
              <p>{image.title}</p>
              <p>{image.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // 修改渲染函数，添加 index 参数
  const renderVenue = (venue, key, index) => ({
    setShow: () => toggleVenue(key),
    isShown: activeVenues[key],
    key: key,
    ...venue
  });

  return (
    <>
      <div className="happeningPage d-none d-lg-block">
        {/* <h6>HAPPENINGS</h6> */}
        <div className="container happeningContainer">
          <div className="row">
            {Object.entries(venueContents)
              .filter(([key, venue]) => !venue.hidden)
              .map(([key, venue], index) => (
                <div
                  key={key}
                  className={index % 2 === 0 ? "leftPadding" : "rightPadding"}
                >
                  {!activeVenues[key]
                    ? renderBigHidden(renderVenue(venue, key, index), index)
                    : renderBigShown(renderVenue(venue, key, index), index)
                  }
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className="d-lg-none">
        <div className="happeningPage">
          {/* <h6>HAPPENINGS</h6> */}
          {Object.entries(venueContents)
            .filter(([key, venue]) => !venue.hidden)
            .map(([key, venue]) => (
              <div key={key} className="miniContainer">
                {!activeVenues[key]
                  ? renderSmallHidden(renderVenue(venue, key, 0))
                  : renderSmallShown(renderVenue(venue, key, 0))
                }
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default HomepageHappening;


